export const MAIN_CONTENT_ANCHOR = 'main-content-anchor';